/**
 * Copyright (c) 2000-present Liferay, Inc. All rights reserved.
 *
 * This library is free software; you can redistribute it and/or modify it under
 * the terms of the GNU Lesser General Public License as published by the Free
 * Software Foundation; either version 2.1 of the License, or (at your option)
 * any later version.
 *
 * This library is distributed in the hope that it will be useful, but WITHOUT
 * ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
 * FOR A PARTICULAR PURPOSE. See the GNU Lesser General Public License for more
 * details.
 */

export default {
	ALERT: 430,
	DOCK: 10,
	DOCK_PARENT: 20,
	DRAG_ITEM: 460,
	DROP_AREA: 440,
	DROP_POSITION: 450,
	MENU: 5000,
	OVERLAY: 1000,
	POPOVER: 1600,
	TOOLTIP: 10000,
	WINDOW: 1200,
};
